import { FormControl, FormLabel, Select } from "@chakra-ui/react";
import {
  AdminBookingUpdateProps,
  RequestProps,
  StudentForm,
  StudentModelProps,
} from "../../types";
import { useSubmitForm } from "../hooks/useSubmitForm";
import StudentFormDrawerLayout from "./StudentFormDrawerLayout";
import { compareClassname } from "../../utils";
import { useState, useEffect } from "react";
import StudentDetailsForm from "./StudentDetailsForm";

const AddStudentDetails = ({
  setToggleDrawer,
  request,
  toggleDrawer,
  clickedStudentIndex,
  addDetailsFn,
  classes,
  students,
  refreshRequests,
}: {
  setToggleDrawer: (type: "add" | "update", triggered: boolean) => void;
  request: RequestProps;
  toggleDrawer: boolean;
  clickedStudentIndex: number;
  addDetailsFn: AdminBookingUpdateProps["updateStudentDetails"];
  classes: string[];
  students: StudentModelProps[];
  refreshRequests: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const [formValues, handleSubmit, updateField, formError, loading, toDefault] =
    useSubmitForm(
      setToggleDrawer,
      addDetailsFn,
      clickedStudentIndex,
      request.students[clickedStudentIndex].expectation,
      request.id,
      {
        class: compareClassname(
          classes,
          request.students[clickedStudentIndex].class
        ),
      },
      refreshRequests
    ) as [
      StudentForm,
      () => { isInvalid: boolean } | StudentForm,
      (key: string, value: string | string[] | number) => void,
      string,
      boolean,
      () => void,
    ];
  const [selectedStudentId, setSelectedStudentId] = useState(0);
  const [subjects, setSubjects] = useState<string[]>([]);
  const [unlinkedStudents, setUnlinkedStudents] = useState<StudentModelProps[]>(
    []
  );

  useEffect(() => {
    setSubjects(request.students[clickedStudentIndex].subjects);
  }, [clickedStudentIndex]);

  // get unlinked students
  useEffect(() => {
    let unlinkedStudents: StudentModelProps[] = [];
    const requestIds = request.students.map((requestStudent) => {
      return requestStudent.id;
    });

    unlinkedStudents = students.filter((studentData) => {
      return !requestIds.includes(studentData.id);
    });

    setUnlinkedStudents(unlinkedStudents);
  }, [students, request.students]);

  useEffect(() => {
    const student = unlinkedStudents.find(
      (student) => student.id === selectedStudentId
    );

    if (student) {
      updateField("age", student.age);
      updateField("name", student.name);
      updateField("gender", student.gender);
      updateField("class", student.class);
      updateField(
        "expectation",
        request.students[clickedStudentIndex].expectation
      );
      updateField("id", student.id);
      setSubjects(student.subjects);
    } else {
      toDefault();
      setSubjects(request.students[clickedStudentIndex].subjects);
    }
  }, [selectedStudentId]);

  return (
    <StudentFormDrawerLayout
      setToggleDrawer={setToggleDrawer}
      toggleDrawer={toggleDrawer}
      handleSubmit={handleSubmit}
      loading={loading}
    >
      {unlinkedStudents.length >= 1 && (
        <FormControl mb="2rem">
          <FormLabel htmlFor="requests">Select existing student</FormLabel>
          <Select
            onChange={(e) => {
              setSelectedStudentId(+e.target.value);
            }}
            value={selectedStudentId}
          >
            {unlinkedStudents.map((student) => (
              <option key={student.id} value={student.id}>
                {student.name}
              </option>
            ))}
            <option value={0}>Create new student</option>
          </Select>
        </FormControl>
      )}
      {selectedStudentId ? (
        <>
          <StudentDetailsForm
            classes={classes}
            formError={formError}
            formValues={formValues}
            updateField={updateField}
            subjects={subjects}
          />
        </>
      ) : (
        <>
          <StudentDetailsForm
            classes={classes}
            formError={formError}
            formValues={formValues}
            updateField={updateField}
            subjects={subjects}
          />
        </>
      )}
    </StudentFormDrawerLayout>
  );
};

export default AddStudentDetails;
